<img class="illustration" *ngIf="value" [src]="value.media.src | imageUrl" />
